import { Action, createReducer, on } from '@ngrx/store'
import * as BasePaddleNumberActions from './base-paddle-numbers.actions'

export const PADDLE_NUMBERS_FEATURE_KEY = 'paddleNumbers'

export interface PaddleNumbersState {
  paddleNumberLoaded: boolean
}

export const initialPaddleNumbersState: PaddleNumbersState = {
  paddleNumberLoaded: true,
}

export const paddleNumbersReducer = createReducer(
  initialPaddleNumbersState,
  on(BasePaddleNumberActions.checkPaddleNumberAvailability, (state) => ({
    ...state,
    paddleNumberLoaded: false,
  })),
  on(BasePaddleNumberActions.checkPaddleNumberAvailabilityCheckDone, (state) => ({
    ...state,
    paddleNumberLoaded: true,
  })),
  on(BasePaddleNumberActions.getNextAvailablePaddleNumber, (state) => ({
    ...state,
    paddleNumberLoaded: false,
  })),
  on(BasePaddleNumberActions.getNextAvailablePaddleNumberDone, (state) => ({
    ...state,
    paddleNumberLoaded: true,
  })),
)

export function reducer(state: PaddleNumbersState | undefined, action: Action) {
  return paddleNumbersReducer(state, action)
}
